var React = require('react');

function ArrowUpRightBlackInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M18.668 45.3334L45.3346 18.6667","stroke":"black","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M18.668 18.6667H45.3346V45.3334","stroke":"black","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ArrowUpRightBlackInline.defaultProps = {"width":"64","height":"64","viewBox":"0 0 64 64","fill":"none"};

module.exports = ArrowUpRightBlackInline;

ArrowUpRightBlackInline.default = ArrowUpRightBlackInline;
